/**
 * PenStyles
 *
 * @group CTA-608
 * @beta
 */
export type PenStyles = {
	foreground: string | null;
	underline: boolean;
	italics: boolean;
	background: string;
	flash: boolean;
};
